<script>
    import axios from 'axios'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import RadioButton from "primevue/radiobutton";

    export default {
        data() {
            return {
                loading: false,
                error: null,
                model: {targetNode: -2}
            }
        },
        props: ["name", "uid"],
        methods: {
            save(){
                let self = this;
                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: this.model
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.error = null
            },
            onOpen() {
                this.model = {
                    targetNode: -2,
                };
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/clustering/' + this.uid + '/delete/double' ;
            },
            btnModalLabel(){
                return this.type === 'import' ? 'Добавить' : 'Удалить';
            }
        },
        components: {
            AdaptersDialog,
            RadioButton,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.cluster.cls_from_double_c')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.delete')"
    >
        <template #content>
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_deleted"
                        name="targetNode"
                        :value="-2"
                    />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_unallocated"
                        name="targetNode"
                        :value="-1"
                    />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
